import { Navigate, Outlet, useLocation } from 'react-router'
import { useAuthStore } from '@/stores'

interface GuestGuardProps {
  children?: React.ReactNode
}

export function GuestGuard({ children }: GuestGuardProps) {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)
  const user = useAuthStore((state) => state.user)
  const location = useLocation()

  if (isAuthenticated) {
    // If email is not verified, redirect to pending verification page
    if (user && !user.emailVerified) {
      return <Navigate to="/verify-email-pending" replace />
    }
    // Redirect to the page they tried to visit or dashboard
    const from = (location.state as { from?: Location })?.from?.pathname || '/dashboard'
    return <Navigate to={from} replace />
  }

  return children ? <>{children}</> : <Outlet />
}
